import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'solarwinds-equipment',
    templateUrl: './solarwinds-equipment.component.html',
    styleUrls: ['./solarwinds-equipment.component.scss'],
    standalone: false
})
export class SolarWindsEquipmentTemplate implements OnInit {
    @Input() group: any[];                  //  The display name of the group of equipment types that we're displaying.
    @Input() items: any[];                  //  The group of equipment types that we're displaying.

    public isGroupExpanded: boolean = false;

    constructor() { }

    public ngOnInit(): void { }
}
